import { handleActions } from 'redux-actions';
import { fromJS } from 'immutable';
import { State } from './model';


const Reducer = handleActions({
  // common
  'creatCase/POST_REQUEST': (state, { payload }) => {
    return state.setIn(['isPosting'], true)
                .setIn(['errMsg'], null);
  },
  'creatCase/POST_SUCCESS': (state, { payload }) => {
    return state.setIn(['isPosting'], false)
                .setIn(['errMsg'], null);
  },
  'creatCase/POST_FAILURE': (state, { payload }) => {
    return state.setIn(['isPosting'], false)
                .setIn(['errMsg'], payload.errMsg);
  },
  'creatCase/POST_CHECK_REQUEST': (state, { payload }) => {
    return state.setIn(['isChecking'], true)
                .setIn(['errMsg'], null);
  },
  'creatCase/POST_CHECK_SUCCESS': (state, { payload }) => {
    return state.setIn(['isChecking'], false)
                .setIn(['errMsg'], null);
  },
  'creatCase/POST_CHECK_FAILURE': (state, { payload }) => {
    return state.setIn(['isChecking'], false)
                .setIn(['errMsg'], payload.errMsg);
  },
  'creatCase/GET_REQUEST': (state, { payload }) => {
    return state.setIn(['isGetting'], true)
                .setIn(['errMsg'], null);
  },
  'creatCase/GET_SUCCESS': (state, { payload }) => {
    return state.setIn(['isGetting'], false)
                .setIn(['errMsg'], null);
  },
  'creatCase/GET_FAILURE': (state, { payload }) => {
    return state.setIn(['isGetting'], false)
                .setIn(['errMsg'], payload.errMsg);
  },
  'creatCase/UPDATE_ERR_MSG': (state, { payload }) => {
    return state.setIn(['errMsg'], '');
  },
  'creatCase/UPDATE_CASE_RELATE_LIST': (state, { payload }) => {
    if (payload.length === 0 ) {
      return state.setIn(['isFetching'], false);
    } else {
      return state.setIn(['caseRelateList'],  fromJS(payload));
    }
  },
  'creatCase/GET_CASE_RELATED_SUCCESS': (state, { payload }) => {
    return state.setIn(['isGettingCaseRelated'], false)
                .setIn(['errMsg'], null);
  },
  'creatCase/GET_CASE_RELATEDT_FAILURE': (state, { payload }) => {
    return state.setIn(['isGettingCaseRelated'], false)
                .setIn(['errMsg'], payload.errMsg);
  },
  'creatCase/UPDATE_CASE_RELATE_LIST': (state, { payload }) => {
    return state.setIn(['caseRelateList'], fromJS(payload));
  },
  'creatCase/UPDATE_CUSTODIAN_CONFLICT': (state, { payload }) => {
    return state.setIn(['custodianConflict'], payload)
  },
}, State);

export default Reducer;